"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var getVariantClass = function getVariantClass(variant) {
  switch (variant) {
    case 'title':
      return {
        variantColor: 'muted',
        variantFont: 'md'
      };

    case 'h2':
      return {
        variantColor: 'muted',
        variantFont: '2xl'
      };

    case 'label':
      return {
        variantColor: 'muted',
        variantFont: 'sm'
      };

    default:
      return {};
  }
};

var TextField = /*#__PURE__*/_react["default"].forwardRef(function TextField(_ref, ref) {
  var color = _ref.color,
      bgColor = _ref.bgColor,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick,
      name = _ref.name,
      id = _ref.id,
      size = _ref.size,
      variant = _ref.variant,
      inline = _ref.inline,
      weight = _ref.weight,
      bold = _ref.bold;

  var _getVariantClass = getVariantClass(variant),
      _getVariantClass$vari = _getVariantClass.variantColor,
      variantColor = _getVariantClass$vari === void 0 ? color : _getVariantClass$vari,
      _getVariantClass$vari2 = _getVariantClass.variantFont,
      variantFont = _getVariantClass$vari2 === void 0 ? size : _getVariantClass$vari2;

  var fontWeight = bold ? 'bold' : weight;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    role: "presentation",
    className: (0, _classnames["default"])('text-field-wrapper', (0, _defineProperty2["default"])({}, "text-".concat(variantColor, " fill-").concat(variantColor), variantColor), (0, _defineProperty2["default"])({}, "bg-".concat(bgColor), bgColor), (0, _defineProperty2["default"])({}, "font-size-".concat(variantFont), variantFont), {
      clickable: onClick
    }, (0, _defineProperty2["default"])({}, "font-weight-".concat(fontWeight), fontWeight), {
      'd-inline': inline
    }, className),
    style: style,
    onClick: onClick,
    name: name,
    id: id
  }, children);
});

TextField.defaultProps = {
  color: null,
  bgColor: null,
  size: null,
  className: '',
  style: {},
  onClick: null,
  name: '',
  id: '',
  variant: null,
  inline: false,
  weight: undefined,
  bold: false
};
TextField.propTypes = {
  color: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  className: _propTypes["default"].string,
  style: _propTypes["default"].shape(),
  onClick: _propTypes["default"].func,
  name: _propTypes["default"].string,
  id: _propTypes["default"].string,

  /** one of [ 'xs', 'md', 'lg', 'lg-xl', 'xl', '2xl', '3xl' ] */
  size: _propTypes["default"].oneOf(['xs', 'md', 'lg', 'lg-xl', 'xl', '2xl', '3xl']),

  /** one of [ 'title', 'label', 'h2' ] */
  variant: _propTypes["default"].oneOf(['title', 'label', 'h2']),

  /** whether text element is of inline display */
  inline: _propTypes["default"].bool,
  bold: _propTypes["default"].bool,

  /** one of [ 'bold', 'reg', 'light' ] */
  weight: _propTypes["default"].oneOf(['bold', 'reg', 'light'])
}; // Hack for withInfo plugin

TextField.displayName = 'TextField';
var _default = TextField;
exports["default"] = _default;